import { StyleSheet, View, Text, Pressable } from "react-native";
//import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { MaterialIcons } from "./VectorIcons";
import { getSchemeStyle } from "../context/helper";

const FirmItem = (props) => {
  const schemeStyles = getSchemeStyle();

  let $firmname = props.item.firmName;
  let $firmaddr = props.item.firmAddress;

  const AddInfo = (props) => {
    if (props.lockedUsers || props.errors) {
      return (
        <View style={styles.errorContainer}>
          {props.lockedUsers && (
            <View style={styles.errorValueContainer}>
              <MaterialIcons name="people-alt" size={18} color={schemeStyles.errorText.color} />
              <Text
                style={[styles.errorText,schemeStyles.errorText]}
              >{`${props.lockedUsers}`}</Text>
            </View>
          )}
          {props.errors && (
            <View style={styles.errorValueContainer}>
              <MaterialIcons name="report-problem" size={18} color={schemeStyles.errorText.color} />
            <Text
              style={[styles.errorText,schemeStyles.errorText]}
            >{`${props.errors.all}`}</Text>
            </View>
          )}
        </View>
      );
    }
    return null;
  };

  return (
    <View style={[styles.firmItem,schemeStyles.BorderC]}>
      <Pressable
        android_ripple={{ color: "#cccccc" }}
        onPress={props.onPressFirm.bind(this, props.id)}
        style={({ pressed }) => pressed && styles.pressedItem}
      >
        <View style={styles.firmTextContainer}>
          <Text style={[styles.firmText,schemeStyles.defaultText]}>{$firmname}</Text>
          {props.noaddr !== true && (
            <>
              <Text style={[styles.firmAddr,schemeStyles.defaultText]}>{$firmaddr}</Text>
              <Text style={[styles.firmAddr,schemeStyles.defaultText]}>{props.item.firmTelefon}</Text>
              <AddInfo lockedUsers={props.item.lockedUsers} errors={props.item.errors} />
            </>
          )}
        </View>
      </Pressable>
    </View>
  );
};

export default FirmItem;

const styles = StyleSheet.create({
  firmItem: {
    borderBottomWidth: 1,
  },
  pressedItem: {
    opacity: 0.5,
  },
  firmTextContainer: {
    padding: 8,
  },
  firmText: {
    fontFamily: "Roboto-MediumItalic",
    fontSize: 20,
  },
  firmAddr: {
    fontFamily: "Roboto-Regular",
    fontSize: 14,
  },
  errorContainer: {
    position: "absolute",
    bottom: 3,
    right: 0,
    flexDirection: "row"
  },
  errorValueContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 10
  },
  errorText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
    color: "#f00",
    marginLeft: 5,
  },
});
